/**
 *
 * @param {string} htmlString
 * @returns HTMLElement
 */
function creteItemElementFromTemplateString(htmlString) {
	const template = document.createElement('template');
	template.innerHTML = htmlString.trim();
	return template.content.firstChild;
}

/**
 * zobrazení jednotlivého souboru a obsluha pro smazání
 * @param {File} file
 * @param {number} i
 * @param {HTMLInputElement} fileInput
 * @param {HTMLElement} fileList
 * @param {DataTransfer} dataTransfer
 */
function addFileToList(file, i, fileInput, fileList, dataTransfer) {
	let fileItem = creteItemElementFromTemplateString(fileList.dataset.customUploadItem);

	let fileItemName = fileItem.querySelector('[data-cutom-upload-item-name]');
	fileItemName.textContent = file.name;

	let removeButton = fileItem.querySelector('[data-custon-upload-item-delete]');
	removeButton.onclick = (e) => {
		e.preventDefault();
		fileItem.remove();

		dataTransfer.items.remove(i);
		fileInput.files = dataTransfer.files;

		if (dataTransfer.items.length === 0) {
			fileList.classList.add('d-none');
		}

		// musíme znovu zavolat handleFiles kvůli přečíslování "i"
		// a následnému mazání - jinak se stalo to, že po smazání souboru s indexem 0
		// nešel smazat soubor s indexem 1, atd...
		handleFiles(fileInput, fileList, dataTransfer);
	};

	fileList.appendChild(fileItem);
	fileList.classList.remove('d-none');
}

/**
 * Zpracování a zobrazení souborů (přetažených nebo vybraných v inputu)
 * @param {HTMLInputElement} fileInput
 * @param {HTMLElement} fileList
 * @param {DataTransfer} dataTransfer
 */
function handleFiles(fileInput, fileList, dataTransfer) {
	fileList.querySelectorAll('div').forEach((div) => {
		div.remove(); // Vyčistíme všechny fileItem
	});

	Array.from(fileInput.files).forEach((file, i) => {
		addFileToList(file, i, fileInput, fileList, dataTransfer);
	});

	let event = new CustomEvent('change', {
		detail: {
			fromHandleFiles: true
		}
	});

	fileInput.dispatchEvent(event);
}

/**
 * @param {HTMLElement} element
 */
export default function (element) {
	element.querySelectorAll('[data-custom-upload-wrapper]').forEach((uploadWrapper) => {
		const fileInput = uploadWrapper.querySelector('input');
		const fileList = uploadWrapper.nextElementSibling;

		// Objekt pro udržení seznamu souborů v aktuálním input poli
		const dataTransfer = new DataTransfer();

		// Událost pro výběr souborů přes input
		fileInput.addEventListener('change', (event) => {
			if (event.detail?.fromHandleFiles === true) {
				return; // ukončíme obsluhu eventu, aby nedošlo k zacyklení
			}

			if (!fileInput.multiple) {
				// Pokud není pole multiple, vyčistíme soubory ve frontě
				dataTransfer.items.clear();
			}

			const files = event.target.files; // Získání přetažených souborů
			const maxFiles = fileInput.dataset.maxFiles ?? null;

			// Přidání nového souboru
			Array.from(files).forEach((file) => {
				if (maxFiles === null || maxFiles > dataTransfer.items.length) {
					dataTransfer.items.add(file);
				}
			});

			// Aktualizace FileList u inputu
			fileInput.files = dataTransfer.files;

			handleFiles(fileInput, fileList, dataTransfer);
		});

		// Přidání třídy při přetažení souboru nad oblast
		uploadWrapper.addEventListener('dragover', (event) => {
			event.preventDefault(); // Zamezení defaultního chování

			const maxFiles = fileInput.dataset.maxFiles ?? null;
			if (maxFiles === null || maxFiles > dataTransfer.items.length) {
				uploadWrapper.classList.add('border-2');
			}
		});

		// Odebrání třídy, když soubor opustí oblast
		uploadWrapper.addEventListener('dragleave', () => {
			uploadWrapper.classList.remove('border-2');
		});

		// Zpracování přetaženého souboru
		uploadWrapper.addEventListener('drop', (event) => {
			event.preventDefault();
			uploadWrapper.classList.remove('border-2');

			const maxFiles = fileInput.dataset.maxFiles ?? null;
			if (maxFiles !== null && maxFiles <= dataTransfer.items.length) {
				// máme-li nastaveno maxFiles a již jsme v dataTransfer tohoto počtu dásáhli, neumožníme vložit soubory
				return;
			}

			if (!fileInput.multiple) {
				// Pokud není pole multiple, vyčistíme soubory ve frontě
				dataTransfer.items.clear();
			}

			const files = event.dataTransfer.files; // Získání přetažených souborů

			// Přidání nového souboru
			Array.from(files).forEach((file) => {
				if (maxFiles === null || maxFiles > dataTransfer.items.length) {
					dataTransfer.items.add(file);
				}
			});

			// Aktualizace FileList u inputu
			fileInput.files = dataTransfer.files;

			handleFiles(fileInput, fileList, dataTransfer); // Přidání souborů
		});
	});
}
